module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAqCAMAAADlP6mgAAAAAXNSR0IArs4c6QAAADxQTFRFAAAAkra2n5+fkpeclJSZkJWZkpSbkZOZkJSakZOakJSZkZSakZSZkJSakZSZkJSakZOZkZSZkZSakJOZZE6xjAAAABN0Uk5TAAcINjdxdYeIiYqdoLG31vj6/BSiBAcAAAC/SURBVDjLfZTbAoIgEAWXoFK7WOz//2sEkVz2HJ9nBlRYOT+90OelcXEMUI26ewqEnUZUxW0skgARFsmAuBVGCkAiFYCRP4AiDWBHWsCM9IARGYA5MgFjZAaGiAV0ERNoIwA4IggokdURIEduFFii3gng0xLbCW/ymjYZ8Cazjl/zu3rWAXDo9s9qdAvw5fvAA9PrEzDq46Gd9B4w9O7iWHoD2PpxeYFeAaj/BgjWM8D0OsQCGWJvqqfn8uCD9AM7zw/Z8UsDswAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-next.png
// module id = 8efH
// module chunks = 0